
export async function bootstrapData() {

  console.log('Running bootstrap script...');

  try {

    // Can add some client startup script here
    
    console.log('Bootstrap script completed successfully.');

  } catch (error) {

    console.error('Error running bootstrap script:', error);

  }
}